import React, { Component } from 'react';
import { connect } from 'react-redux'
import { do_action } from '../../actions'

class PmDuration extends Component {
    constructor(props) {
        super(props)
        this.state = {
            duration: 0,
            total_price: 0
        }
    }

    componentWillMount() {
        do_action('get_pm_quote_price', { quote_id: this.props.quote, pm_id: this.props.vendor._id })
            .then(data => {
                if (data.signal) {
                    let pmPrice = data.data
                    if (pmPrice && pmPrice._id) {
                        this.setState({
                            duration: pmPrice.duration,
                            total_price: pmPrice.price
                        })

                        this.props.setDuration(pmPrice)
                    }
                }
            })
            .catch(err => console.log(err));
    }

    confirmChangeDuration = () => {
        if (this.state.duration === '') return alert('Duration required');
        if (window.confirm('Are you sure to confirm this estimate duration')) {
            do_action('create_pm_quote_price', { quote_id: this.props.quote, pm_id: this.props.vendor._id, price: this.state.total_price, duration: this.state.duration })
                .then(data => console.log(data))
                .catch(err => console.log(err))
        }
    }

    renderPmOverview = () =>
        <div className="block-room">
            <div className="clearfix panen-heading">
                <div className="pull-left">
                    <div className="big-title">Price</div>
                </div>
                {this.props.quoteState == 0 && (
                    <div className="pull-right">
                        <a href="#" onClick={this.confirmChangeDuration.bind(this)} className="bg-blue select">
                            Change duration
                        </a>
                    </div>
                )}
                
            </div>
            <div className="panen-body">
                <p className="tit fontMedium">Total Price ($)</p>
                <div className="form-group">
                    <input type="number" className="form-control form-control-mix" name="total_price" value={this.state.total_price} onChange={this.changeDuration.bind(this)}/>
                </div>
                <p className="tit fontMedium">Estimated Duration (days)</p>
                <div className="form-group">
                    <input type="number" className="form-control form-control-mix" name="duration" value={this.state.duration} onChange={this.changeDuration.bind(this)} />
                </div>
            </div>
        </div>

    changeDuration = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })

        let newDuration = Object.assign({
            duration: this.state.duration,
            total_price: this.state.total_price
        }, {
            [e.target.name]: e.target.value
        })

        this.props.setDuration(newDuration)
    }

    render() {
        return (
            <div>

                {this.renderPmOverview()}
                
            </div>
        );
    }
}

export default PmDuration;